module.exports = {"baseUrl":"http://3.6.64.218:3001","downloadButton":{"enable":true,"postgresUrl":null,"i2ocApplicationUrl":null}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 220
// module chunks = 1